'use strict';

var getPhrasePropTypes = require('../../../../_virtual/getPhrasePropTypes.js_commonjs-exports.js');
var interopRequireDefault = require('../../node_modules/@babel/runtime/helpers/interopRequireDefault.js');
var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectSpread = require('../../node_modules/@babel/runtime/helpers/objectSpread.js');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

(function (exports) {

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPhrasePropTypes;

var _defineProperty2 = _interopRequireDefault(defineProperty);

var _objectSpread4 = _interopRequireDefault(objectSpread);

var _propTypes = _interopRequireDefault(PropTypes__default["default"]);

function getPhrasePropTypes(defaultPhrases) {
  return Object.keys(defaultPhrases).reduce(function (phrases, key) {
    return (0, _objectSpread4["default"])({}, phrases, (0, _defineProperty2["default"])({}, key, _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].node])));
  }, {});
}
}(getPhrasePropTypes.__exports));
